import React from 'react';
import PropTypes from 'prop-types';
import { roundNumber } from 'utils/general';

function ComponentsComparisonTable(props) {
  const { data, tableIndex = 0 } = props;
  const backgroundClasses = ['-b1', '-b2', '-b3'];
  const getBackgroundClass = (index) => {
    const selectedIndex = index % 3;
    return backgroundClasses[selectedIndex];
  };

  return (
    <article className="border-bottom-0">
      <div className="row">
        <div className="table column small-12">
          <table className="c-table">
            <tbody>
              {data.map((el, index) => (
                <tr
                  className={`${
                    !el.isSubComponent
                      ? 'category-data-wrapper'
                      : 'subcomponent-data-wrapper'
                  } ${getBackgroundClass(tableIndex)}`}
                  key={index}
                >
                  <td
                    className={` row-item-label ${
                      !el.isSubComponent ? 'category-data' : 'subcomponent-data'
                    }`}
                  >
                    <span>{el.name}</span>
                  </td>
                  <td
                    className={` row-item-score ${
                      !el.isSubComponent ? 'category-data' : 'subcomponent-data'
                    }`}
                  >
                    <p className="score-item"> {roundNumber(el.score, '-')}</p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </article>
  );
}

ComponentsComparisonTable.propTypes = {
  data: PropTypes.array,
  tableIndex: PropTypes.number
};

export default ComponentsComparisonTable;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/ComponentsComparisonTable.jsx